export const TLAOK_DIRECTIVES = [
  {
    "key": "aberration",
    "value": "Aberration"
  },
  {
    "key": "acolytes",
    "value": "Acolytes"
  },
  {
    "key": "acute-senses",
    "value": "Acute Senses"
  },
  {
    "key": "adaptability",
    "value": "Adaptability"
  },
  {
    "key": "adrenal-hysteria",
    "value": "Adrenal Hysteria"
  },
  {
    "key": "advanced-cavalry-training",
    "value": "Advanced Cavalry Training"
  },
  {
    "key": "advanced-infantry-training",
    "value": "Advanced Infantry Training"
  },
  {
    "key": "advanced-scout-training",
    "value": "Advanced Scout Training"
  },
  {
    "key": "advanced-supply-logistics",
    "value": "Advanced Supply Logistics"
  },
  {
    "key": "advanced-target-training",
    "value": "Advanced Target Training"
  },
  {
    "key": "advanced-vanguard-training",
    "value": "Advanced Vanguard Training"
  },
  {
    "key": "aetheric-guidance",
    "value": "Aetheric Guidance"
  },
  {
    "key": "aetheric-marker",
    "value": "Aetheric Marker"
  },
  {
    "key": "aggression-directive",
    "value": "Aggression Directive"
  },
  {
    "key": "aghm-is-eternal",
    "value": "Aghm is Eternal"
  },
  {
    "key": "aim-for-the-head",
    "value": "Aim For the Head"
  },
  {
    "key": "aimed-shot",
    "value": "Aimed Shot"
  },
  {
    "key": "air-elemental",
    "value": "Air Elemental"
  },
  {
    "key": "air-step",
    "value": "Air Step"
  },
  {
    "key": "alternate-programming",
    "value": "Alternate Programming "
  },
  {
    "key": "alternate-programming ",
    "value": "Alternate Programming "
  },
  {
    "key": "alternate-soma",
    "value": "Alternate Soma"
  },
  {
    "key": "ambush",
    "value": "Ambush"
  },
  {
    "key": "anastegma-brand-of-the-faithless",
    "value": "Anastegma, Brand of the Faithless"
  },
  {
    "key": "ancestors-blessing",
    "value": "Ancestors' Blessing"
  },
  {
    "key": "ancient-tactician",
    "value": "Ancient Tactician"
  },
  {
    "key": "andromachos",
    "value": "Andromachos"
  },
  {
    "key": "animalistic-focus",
    "value": "Animalistic Focus"
  },
  {
    "key": "animate-vessel",
    "value": "Animate Vessel"
  },
  {
    "key": "anticythian-alloy-gears",
    "value": "Anticythian Alloy Gears"
  },
  {
    "key": "apex-hyperyparixa",
    "value": "Apex Hyperyparixa"
  },
  {
    "key": "apex-master",
    "value": "Apex Master"
  },
  {
    "key": "apoptotic-spasms",
    "value": "Apoptotic Spasms"
  },
  {
    "key": "apoptotic-spasms-alt",
    "value": "Apoptotic Spasms"
  },
  {
    "key": "aqueous-branding",
    "value": "Aqueous Branding"
  },
  {
    "key": "arcane-harvest",
    "value": "Arcane Harvest"
  },
  {
    "key": "arcane-relay",
    "value": "Arcane Relay"
  },
  {
    "key": "arcing-fire",
    "value": "Arcing Fire"
  },
  {
    "key": "arena-champion",
    "value": "Arena Champion"
  },
  {
    "key": "aristia",
    "value": "Aristia"
  },
  {
    "key": "aristia-de",
    "value": "Aristia"
  },
  {
    "key": "armor-of-dominion",
    "value": "Armor of Dominion"
  },
  {
    "key": "armor-of-rime",
    "value": "Armor of Rime"
  },
  {
    "key": "armor-of-the-living-saint",
    "value": "Armor of the Living Saint"
  },
  {
    "key": "armor-piercing",
    "value": "Armor Piercing X"
  },
  {
    "key": "armsmaster",
    "value": "Armsmaster"
  },
  {
    "key": "army-of-lions",
    "value": "Army of Lions"
  },
  {
    "key": "army-rules-100k",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-dominion",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-dweghom",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-nords",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-sorcerers",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-spires",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-states",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-wadrhun",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-weavers",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-yoroni",
    "value": "Army Rules"
  },
  {
    "key": "arrogance",
    "value": "Arrogance"
  },
  {
    "key": "art-of-war",
    "value": "Art of War"
  },
  {
    "key": "aspect-of-fenrir",
    "value": "Aspect of Fenrir"
  },
  {
    "key": "aspect-of-the-avenger",
    "value": "Aspect of the Avenger"
  },
  {
    "key": "aspect-of-the-redeemer",
    "value": "Aspect of the Redeemer"
  },
  {
    "key": "assassination-directive",
    "value": "Assassination Directive"
  },
  {
    "key": "assault-preceptor",
    "value": "Assault Preceptor"
  },
  {
    "key": "atalanta-s-spear",
    "value": "Atalanta's Spear"
  },
  {
    "key": "aura",
    "value": "Aura"
  },
  {
    "key": "aura-of-death",
    "value": "Aura of Death X"
  },
  {
    "key": "aura-of-malice",
    "value": "Aura of Malice"
  },
  {
    "key": "authority",
    "value": "Authority"
  },
  {
    "key": "automaton",
    "value": "Automaton"
  },
  {
    "key": "avatar-of-nature",
    "value": "Avatar of Nature"
  },
  {
    "key": "avatar-projection",
    "value": "Avatar Projection"
  },
  {
    "key": "aventine-armor",
    "value": "Aventine Armor"
  },
  {
    "key": "bakkian-token",
    "value": "Bakkian Token"
  },
  {
    "key": "banner-of-elemental-dominion",
    "value": "Banner of Elemental Dominion"
  },
  {
    "key": "barrage",
    "value": "Barrage X"
  },
  {
    "key": "bastion",
    "value": "Bastion X"
  },
  {
    "key": "battery",
    "value": "Battery"
  },
  {
    "key": "battlefield-drills",
    "value": "Battlefield Drills"
  },
  {
    "key": "battlefield-orders",
    "value": "Battlefield Orders"
  },
  {
    "key": "battlefield-tactics",
    "value": "Battlefield Tactics"
  },
  {
    "key": "beads-of-death",
    "value": "Beads of Death"
  },
  {
    "key": "bear-aspect",
    "value": "Bear"
  },
  {
    "key": "benediction-of-the-black-sun",
    "value": "Benediction of the Black Sun"
  },
  {
    "key": "bergont-raegh",
    "value": "Bergont Raegh"
  },
  {
    "key": "best-money-can-buy",
    "value": "Best Money can Buy"
  },
  {
    "key": "bestial-devolution",
    "value": "Bestial Devolution"
  },
  {
    "key": "biotic-renewal",
    "value": "Biotic Renewal"
  },
  {
    "key": "biotic-renewal-de",
    "value": "Biotic Renewal"
  },
  {
    "key": "bird-of-prey",
    "value": "Bird of Prey"
  },
  {
    "key": "blackflame-coruscation",
    "value": "Blackflame Coruscation"
  },
  {
    "key": "blade-masters",
    "value": "Blade Masters"
  },
  {
    "key": "blades-of-eakides",
    "value": "Blades of Eakides"
  },
  {
    "key": "blades-of-the-ancestor",
    "value": "Blades of the Ancestor"
  },
  {
    "key": "blasphemous-mesa",
    "value": "Blasphemous Mesa"
  },
  {
    "key": "blasphemous-power",
    "value": "Blasphemous Power"
  },
  {
    "key": "blasphemous-soma",
    "value": "Blasphemous Soma"
  },
  {
    "key": "blazing-souls",
    "value": "Blazing Souls"
  },
  {
    "key": "blessed",
    "value": "Blessed"
  },
  {
    "key": "blodiss-the-blood-thirster",
    "value": "Blóðíss, the Blood Thirster"
  },
  {
    "key": "blood",
    "value": "Blood"
  },
  {
    "key": "blood-of-the-einherjar",
    "value": "Blood of the Einherjar"
  },
  {
    "key": "blood-of-the-forge-god",
    "value": "Blood of the Forge God"
  },
  {
    "key": "blood-to-be-spilled",
    "value": "Blood to be Spilled"
  },
  {
    "key": "blood-to-water",
    "value": "Blood to Water"
  },
  {
    "key": "bloody-minded-focus",
    "value": "Bloody-Minded Focus"
  },
  {
    "key": "bloody-sacrifice",
    "value": "Bloody Sacrifice"
  },
  {
    "key": "blossom-in-the-wind",
    "value": "Blossom in the Wind"
  },
  {
    "key": "blurred-vision",
    "value": "Blurred Vision"
  },
  {
    "key": "bodyguards",
    "value": "Bodyguards"
  },
  {
    "key": "bombardment",
    "value": "Bombardment"
  },
  {
    "key": "bombing-run",
    "value": "Bombing Run"
  },
  {
    "key": "bond-of-falcons",
    "value": "Bond of Falcons"
  },
  {
    "key": "bound-to-the-elements",
    "value": "Bound to the Elements"
  },
  {
    "key": "brace-for-impact",
    "value": "Brace for Impact"
  },
  {
    "key": "bravery",
    "value": "Bravery"
  },
  {
    "key": "break-their-lines",
    "value": "Break Their Lines"
  },
  {
    "key": "breath",
    "value": "Breath"
  },
  {
    "key": "bringer-of-the-deluge",
    "value": "Bringer of the Deluge"
  },
  {
    "key": "bringing-back-the-children-of-fire",
    "value": "Bringing Back the Children of Fire"
  },
  {
    "key": "bringing-back-the-children-of-the-north",
    "value": "Bringing Back the Children of the North"
  },
  {
    "key": "brittle",
    "value": "Brittle"
  },
  {
    "key": "broken-ground",
    "value": "Broken Ground"
  },
  {
    "key": "brood-of-omgorah",
    "value": "Brood of Omgorah"
  },
  {
    "key": "brutal-impact",
    "value": "Brutal Impact X"
  },
  {
    "key": "brute-force",
    "value": "Brute Force"
  },
  {
    "key": "burn-to-cinders",
    "value": "Burn to Cinders"
  },
  {
    "key": "but-first",
    "value": "But First"
  },
  {
    "key": "cacophony",
    "value": "Cacophony"
  },
  {
    "key": "caelestine-banner",
    "value": "Caelestine Banner"
  },
  {
    "key": "calamitas-blade-of-the-caelesor",
    "value": "Calamitas, Blade of the Caelesor"
  },
  {
    "key": "caledburn",
    "value": "Caledburn"
  },
  {
    "key": "call-fog",
    "value": "Call Fog"
  },
  {
    "key": "call-forth-the-deep",
    "value": "Call forth the Deep"
  },
  {
    "key": "call-the-hunt",
    "value": "Call the Hunt"
  },
  {
    "key": "calm-strategist",
    "value": "Calm Strategist"
  },
  {
    "key": "captain",
    "value": "Captain"
  },
  {
    "key": "carrier-of-the-godflesh",
    "value": "Carrier of the Godflesh"
  },
  {
    "key": "catabolic-node",
    "value": "Catabolic Node"
  },
  {
    "key": "catalytic-rupture",
    "value": "Catalytic Rupture"
  },
  {
    "key": "cauterize",
    "value": "Cauterize"
  },
  {
    "key": "cautious-strike",
    "value": "Cautious Strike"
  },
  {
    "key": "ceaseless-hunt",
    "value": "Ceaseless Hunt"
  },
  {
    "key": "chain-reaction",
    "value": "Chain Reaction"
  },
  {
    "key": "champion-s-horns",
    "value": "Champion's Horns"
  },
  {
    "key": "change-flanks",
    "value": "Change Flanks!"
  },
  {
    "key": "cheerful",
    "value": "Cheerful"
  },
  {
    "key": "chrysaor-s-helmet",
    "value": "Chrysaor's Helmet"
  },
  {
    "key": "cleave",
    "value": "Cleave X"
  },
  {
    "key": "clockwork-parade",
    "value": "Clockwork Parade"
  },
  {
    "key": "close-the-gap",
    "value": "Close the Gap!"
  },
  {
    "key": "coils-of-the-serpent",
    "value": "Coils of the Serpent"
  },
  {
    "key": "combat-directives",
    "value": "Combat Directives"
  },
  {
    "key": "combat-directives-alt",
    "value": "Combat Directives"
  },
  {
    "key": "combat-maneuvers",
    "value": "Combat Maneuvers"
  },
  {
    "key": "combined-arms-drills",
    "value": "Combined Arms Drills"
  },
  {
    "key": "company-colors",
    "value": "Company Colors"
  },
  {
    "key": "concentrated-assault",
    "value": "Concentrated Assault"
  },
  {
    "key": "conflagration",
    "value": "Conflagration"
  },
  {
    "key": "consecrated-mitre",
    "value": "Consecrated Mitre"
  },
  {
    "key": "conviction",
    "value": "Conviction"
  },
  {
    "key": "convulsive-doom",
    "value": "Convulsive Doom"
  },
  {
    "key": "coruscation",
    "value": "Coruscation"
  },
  {
    "key": "counter-attack",
    "value": "Counter-Attack"
  },
  {
    "key": "court-of-air",
    "value": "Court of Air"
  },
  {
    "key": "court-of-earth",
    "value": "Court of Earth"
  },
  {
    "key": "court-of-fire",
    "value": "Court of Fire"
  },
  {
    "key": "court-of-summer",
    "value": "Court of Summer"
  },
  {
    "key": "court-of-water",
    "value": "Court of Water"
  },
  {
    "key": "court-of-winter",
    "value": "Court of Winter"
  },
  {
    "key": "crescendo",
    "value": "Crescendo"
  },
  {
    "key": "crop-rotation",
    "value": "Crop Rotation"
  },
  {
    "key": "crow-aspect",
    "value": "Crow"
  },
  {
    "key": "crucible-s-fire",
    "value": "Crucible's Fire"
  },
  {
    "key": "crushing-avalanche",
    "value": "Crushing Avalanche"
  },
  {
    "key": "crushing-force",
    "value": "Crushing Force"
  },
  {
    "key": "cthonic-flame",
    "value": "Cthonic Flame"
  },
  {
    "key": "cuirass-of-hazlia-s-shadow",
    "value": "Cuirass of Hazlia's Shadow"
  },
  {
    "key": "cult-of-conquest",
    "value": "Cult of Conquest"
  },
  {
    "key": "cult-of-death",
    "value": "Cult of Death"
  },
  {
    "key": "cult-of-war",
    "value": "Cult of War"
  },
  {
    "key": "cultists-of-conquest",
    "value": "Cultists of Conquest"
  },
  {
    "key": "cultists-of-death",
    "value": "Cultists of Death"
  },
  {
    "key": "cultists-of-famine",
    "value": "Cultists of Famine"
  },
  {
    "key": "cultists-of-war",
    "value": "Cultists of War"
  },
  {
    "key": "cultivated-muscle-memory",
    "value": "Cultivated Muscle Memory"
  },
  {
    "key": "cure",
    "value": "Cure"
  },
  {
    "key": "cyclic-adaptation",
    "value": "Cyclic Adaptation"
  },
  {
    "key": "cyclone",
    "value": "Cyclone"
  },
  {
    "key": "dancing-scimitar",
    "value": "Dancing Scimitar"
  },
  {
    "key": "dancing-scimitar-de",
    "value": "Dancing Scimitar"
  },
  {
    "key": "dancing-shadows",
    "value": "Dancing Shadows"
  },
  {
    "key": "dark-cenotaph",
    "value": "Dark Cenotaph"
  },
  {
    "key": "dark-hand-of-the-scholae",
    "value": "Dark Hand of the Scholae"
  },
  {
    "key": "dark-immolation",
    "value": "Dark Immolation"
  },
  {
    "key": "heart-of-winter",
    "value": "Heart of Winter"
  },
  {
    "key": "dark-shepherd",
    "value": "Dark Shepherd"
  },
  {
    "key": "dark-supplication",
    "value": "Dark Supplication"
  },
  {
    "key": "dauntless",
    "value": "Dauntless"
  },
  {
    "key": "deadly-blades",
    "value": "Deadly Blades"
  },
  {
    "key": "deadly-shot",
    "value": "Deadly Shot"
  },
  {
    "key": "deadshots",
    "value": "Deadshots"
  },
  {
    "key": "death-from-above",
    "value": "Death from Above"
  },
  {
    "key": "death-s-gaze",
    "value": "Death's Gaze"
  },
  {
    "key": "death-s-reach",
    "value": "Death's Reach"
  },
  {
    "key": "decay",
    "value": "Decay"
  },
  {
    "key": "degenerative-aura",
    "value": "Degenerative Aura"
  },
  {
    "key": "dehydrate",
    "value": "Dehydrate"
  },
  {
    "key": "denizens-of-the-upper-planes",
    "value": "Denizens of the Upper Planes"
  },
  {
    "key": "descendant-of-the-brazen-race",
    "value": "Descendant of the Brazen Race"
  },
  {
    "key": "designate-target",
    "value": "Designate Target"
  },
  {
    "key": "devastating-charge",
    "value": "Devastating Charge"
  },
  {
    "key": "devoted-to-hazlia",
    "value": "Devoted to Hazlia"
  },
  {
    "key": "devouring-moulder",
    "value": "Devouring Moulder"
  },
  {
    "key": "devout",
    "value": "Devout"
  },
  {
    "key": "direct-assault",
    "value": "Direct Assault!"
  },
  {
    "key": "discordance",
    "value": "Discordance"
  },
  {
    "key": "dismay",
    "value": "Dismay"
  },
  {
    "key": "disorienting-strikes",
    "value": "Disorienting Strikes"
  },
  {
    "key": "disperse",
    "value": "Disperse"
  },
  {
    "key": "disruptive",
    "value": "Disruptive"
  },
  {
    "key": "disseminate",
    "value": "Disseminate"
  },
  {
    "key": "dissonance",
    "value": "Dissonance"
  },
  {
    "key": "divine-protection",
    "value": "Divine Protection"
  },
  {
    "key": "divine-purpose",
    "value": "Divine Purpose"
  },
  {
    "key": "divine-sanction",
    "value": "Divine Sanction"
  },
  {
    "key": "divine-shard",
    "value": "Divine Shard"
  },
  {
    "key": "divinity-grace",
    "value": "Divinity Grace"
  },
  {
    "key": "dominate",
    "value": "Dominate"
  },
  {
    "key": "dominating-presence",
    "value": "Dominating Presence"
  },
  {
    "key": "dori",
    "value": "Dori"
  },
  {
    "key": "dorilates",
    "value": "Dorilates"
  },
  {
    "key": "double-time",
    "value": "Double Time"
  },
  {
    "key": "draegbhrud",
    "value": "Draegbhrud"
  },
  {
    "key": "dragon-aspect",
    "value": "Dragon"
  },
  {
    "key": "draic-rider",
    "value": "Draic Rider"
  },
  {
    "key": "drain-will",
    "value": "Drain Will"
  },
  {
    "key": "draw-them-in",
    "value": "Draw Them In!"
  },
  {
    "key": "dread",
    "value": "Dread"
  },
  {
    "key": "drillmaster",
    "value": "Drillmaster"
  },
  {
    "key": "drive",
    "value": "Drive"
  },
  {
    "key": "drive-for-justice",
    "value": "Drive for Justice"
  },
  {
    "key": "driven-by-carnage",
    "value": "Driven by Carnage"
  },
  {
    "key": "drum-beast-rider",
    "value": "Drum Beast Rider"
  },
  {
    "key": "drum-beat",
    "value": "Drum Beat"
  },
  {
    "key": "duelist",
    "value": "Duelist"
  },
  {
    "key": "dynastic-alliances",
    "value": "Dynastic Alliances"
  },
  {
    "key": "dysthymic-hysteria",
    "value": "Dysthymic Hysteria"
  },
  {
    "key": "earth-elemental",
    "value": "Earth Elemental"
  },
  {
    "key": "earth-school",
    "value": "Earth School"
  },
  {
    "key": "earth-to-mud",
    "value": "Earth to Mud"
  },
  {
    "key": "earthquake",
    "value": "Earthquake"
  },
  {
    "key": "eccentric-fighting-style",
    "value": "Eccentric Fighting Style"
  },
  {
    "key": "echoes-of-dheureghodh",
    "value": "Echoes of Dheureghodh"
  },
  {
    "key": "echoes-of-whispers",
    "value": "Echoes of Whispers"
  },
  {
    "key": "elding-the-skypiercer",
    "value": "Elding, the Skypiercer"
  },
  {
    "key": "elemental-assault",
    "value": "Elemental Assault"
  },
  {
    "key": "elemental-conduit",
    "value": "Elemental Conduit"
  },
  {
    "key": "elemental-confluence",
    "value": "Elemental Confluence"
  },
  {
    "key": "elemental-dominance",
    "value": "Elemental Dominance"
  },
  {
    "key": "elemental-dominion",
    "value": "Elemental Dominion"
  },
  {
    "key": "elemental-feedback",
    "value": "Elemental Feedback"
  },
  {
    "key": "elemental-missile",
    "value": "Elemental Missile"
  },
  {
    "key": "elemental-potency",
    "value": "Elemental Potency"
  },
  {
    "key": "elemental-projection",
    "value": "Elemental Projection"
  },
  {
    "key": "elemental-prowess",
    "value": "Elemental Prowess"
  },
  {
    "key": "elemental-tether",
    "value": "Elemental Tether"
  },
  {
    "key": "elemental-vortex",
    "value": "Elemental Vortex"
  },
  {
    "key": "eleutherea-giver-of-mercy",
    "value": "Eleutherea, Giver of Mercy"
  },
  {
    "key": "elysian-fragment",
    "value": "Elysian Fragment"
  },
  {
    "key": "elysian-fragment-de",
    "value": "Elysian Fragment"
  },
  {
    "key": "eminence",
    "value": "Eminence"
  },
  {
    "key": "encase",
    "value": "Encase"
  },
  {
    "key": "endless-hunger",
    "value": "Endless Hunger"
  },
  {
    "key": "enlightened",
    "value": "Enlightened"
  },
  {
    "key": "enlightening-fury",
    "value": "Enlightening Fury"
  },
  {
    "key": "enrage",
    "value": "Enrage"
  },
  {
    "key": "epigenetic-trigger",
    "value": "Epigenetic Trigger"
  },
  {
    "key": "epigenetic-trigger-sr",
    "value": "Epigenetic Trigger"
  },
  {
    "key": "eruption",
    "value": "Eruption"
  },
  {
    "key": "essence-transfer",
    "value": "Essence Transfer"
  },
  {
    "key": "eternal-discipline",
    "value": "Eternal Discipline"
  },
  {
    "key": "exemplar",
    "value": "Exemplar"
  },
  {
    "key": "exhortation-of-eternal-faith",
    "value": "Exhortation of Eternal Faith"
  },
  {
    "key": "expert-hunters",
    "value": "Expert Hunters"
  },
  {
    "key": "expert-scouts",
    "value": "Expert Scouts"
  },
  {
    "key": "exploit-flanks",
    "value": "Exploit Flanks"
  },
  {
    "key": "exploitation-of-divine-vanity",
    "value": "Exploitation of Divine Vanity"
  },
  {
    "key": "eye-of-the-storm",
    "value": "Eye of the Storm"
  },

  {
    "key": "fan-the-flames",
    "value": "Fan the Flames"
  },
  {
    "key": "far-sight",
    "value": "Far Sight"
  },
  {
    "key": "favored-of-hormus",
    "value": "Favored of Hormus"
  },
  {
    "key": "fear",
    "value": "Fear"
  },
  {
    "key": "fearless",
    "value": "Fearless"
  },
  {
    "key": "fearsome",
    "value": "Fearsome"
  },
  {
    "key": "featherblade",
    "value": "Featherblade"
  },
  {
    "key": "feral-hunters",
    "value": "Feral Hunters"
  },
  {
    "key": "ferric-throne",
    "value": "Ferric Throne"
  },
  {
    "key": "ferro-ossified-carapace",
    "value": "Ferro-Ossified Carapace"
  },
  {
    "key": "fervor",
    "value": "Fervor"
  },
  {
    "key": "field-studies",
    "value": "Field Studies"
  },
  {
    "key": "fiend-hunter",
    "value": "Fiend Hunter"
  },
  {
    "key": "fiery-dominion",
    "value": "Fiery Dominion"
  },
  {
    "key": "figurehead-of-the-naglfar",
    "value": "Figurehead of the Naglfar"
  },
  {
    "key": "fire-and-advance",
    "value": "Fire and Advance"
  },
  {
    "key": "fire-dart",
    "value": "Fire Dart"
  },
  {
    "key": "fire-elemental",
    "value": "Fire Elemental"
  },
  {
    "key": "fire-school",
    "value": "Fire School"
  },
  {
    "key": "fireball",
    "value": "Fireball"
  },
  {
    "key": "fires-of-the-descent",
    "value": "Fires of the Descent"
  },
  {
    "key": "first-born-of-war",
    "value": "First Born of War"
  },
  {
    "key": "first-in-the-fray",
    "value": "First in the Fray"
  },
  {
    "key": "flame-wall",
    "value": "Flame Wall"
  },
  {
    "key": "flamecaster",
    "value": "Flamecaster"
  },
  {
    "key": "flames-of-vengeance",
    "value": "Flames of Vengeance"
  },
  {
    "key": "flamethrower",
    "value": "Flamethrower"
  },
  {
    "key": "flank",
    "value": "Flank"
  },
  {
    "key": "flawless-drill",
    "value": "Flawless Drill"
  },
  {
    "key": "flawless-strikes",
    "value": "Flawless Strikes"
  },
  {
    "key": "flint-knapper",
    "value": "Flint Knapper"
  },
  {
    "key": "flow",
    "value": "Flow"
  },
  {
    "key": "flowing-stride",
    "value": "Flowing Stride"
  },
  {
    "key": "fluid-formation",
    "value": "Fluid Formation"
  },
  {
    "key": "flurry",
    "value": "Flurry"
  },
  {
    "key": "flux-powered",
    "value": "Flux-Powered"
  },
  {
    "key": "fly",
    "value": "Fly"
  },
  {
    "key": "font-of-dark-power",
    "value": "Font of Dark Power"
  },
  {
    "key": "forced-march",
    "value": "Forced March"
  },
  {
    "key": "forged-by-the-elements",
    "value": "Forged By the Elements"
  },
  {
    "key": "forged-in-battle",
    "value": "Forged in Battle"
  },
  {
    "key": "forgemaster",
    "value": "Forgemaster"
  },
  {
    "key": "forlorn-drive",
    "value": "Forlorn Drive"
  },
  {
    "key": "forward-force",
    "value": "Forward Force"
  },
  {
    "key": "front-of-the-line",
    "value": "Front of the Line"
  },
  {
    "key": "fruit-of-the-golden-tree",
    "value": "Fruit of the Golden Tree"
  },
  {
    "key": "fudoshin",
    "value": "Fudoshin"
  },
  {
    "key": "fury",
    "value": "Fury"
  },
  {
    "key": "fury-of-the-tempest",
    "value": "Fury of the Tempest"
  },
  {
    "key": "get-in-position",
    "value": "Get in Position"
  },
  {
    "key": "gifted-in-fire",
    "value": "Gifted in Fire"
  },
  {
    "key": "gifted-in-fire-de",
    "value": "Gifted in Fire"
  },
  {
    "key": "gifted-mortals",
    "value": "Gifted Mortals"
  },
  {
    "key": "gifts-of-the-earth",
    "value": "Gifts of the Earth"
  },
  {
    "key": "gilded-rampart",
    "value": "Gilded Rampart"
  },
  {
    "key": "gilded-statue",
    "value": "Gilded Statue"
  },
  {
    "key": "gladiator",
    "value": "Gladiator"
  },
  {
    "key": "glimmer-of-faith",
    "value": "Glimmer of Faith"
  },
  {
    "key": "glimmers-of-a-golden-age",
    "value": "Glimmers of a Golden Age"
  },
  {
    "key": "glorious-charge",
    "value": "Glorious Charge"
  },
  {
    "key": "glory-of-valhalla",
    "value": "Glory of Valhalla"
  },
  {
    "key": "gorged",
    "value": "Gorged"
  },
  {
    "key": "graceful-combatant",
    "value": "Graceful Combatant"
  },
  {
    "key": "graft-of-fire",
    "value": "Graft of Fire"
  },
  {
    "key": "grafted-limbs",
    "value": "Grafted Limbs"
  },
  {
    "key": "grant-virulence",
    "value": "Grant Virulence"
  },
  {
    "key": "grave-step",
    "value": "Grave Step"
  },
  {
    "key": "grotesque-elixir",
    "value": "Grotesque Elixir"
  },
  {
    "key": "guide",
    "value": "Guide"
  },
  {
    "key": "guided-pollenization",
    "value": "Guided Pollenization"
  },
  {
    "key": "gunbai",
    "value": "Gunbai"
  },
  {
    "key": "halitotic-fetor",
    "value": "Halitotic Fetor"
  },
  {
    "key": "hammer-and-anvil",
    "value": "Hammer and Anvil"
  },
  {
    "key": "hannya",
    "value": "Hannya"
  },
  {
    "key": "harbingers-of-seasons",
    "value": "Harbingers of Seasons"
  },
  {
    "key": "hardened",
    "value": "Hardened X"
  },
  {
    "key": "harvest-of-the-fallen",
    "value": "Harvest of the Fallen"
  },
  {
    "key": "hauchiwa",
    "value": "Hauchiwa"
  },
  {
    "key": "hazlia-s-touch",
    "value": "Hazlia's Touch"
  },
  {
    "key": "heart-of-the-mountain",
    "value": "Heart of the Mountain"
  },
  {
    "key": "heart-of-the-mountain-de",
    "value": "Heart of the Mountain"
  },
  {
    "key": "hearts-of-ice",
    "value": "Hearts of Ice"
  },
  {
    "key": "heavenly-blessing",
    "value": "Heavenly Blessing"
  },
  {
    "key": "hela-s-caress",
    "value": "Hela's Caress"
  },
  {
    "key": "hellbringer-sorcerer",
    "value": "Hellbringer Sorcerer"
  },
  {
    "key": "helm-of-nike",
    "value": "Helm of Nike"
  },
  {
    "key": "hephaestian-alloys",
    "value": "Hephaestian Alloys"
  },
  {
    "key": "herald-of-everrusk",
    "value": "Herald of Everrusk"
  },
  {
    "key": "herald-of-fire",
    "value": "Herald of Fire"
  },
  {
    "key": "herald-of-magma",
    "value": "Herald of Magma"
  },
  {
    "key": "herald-of-stone",
    "value": "Herald of Stone"
  },
  {
    "key": "herald-of-the-forge-god",
    "value": "Herald of the Forge God"
  },
  {
    "key": "herald-of-the-storm",
    "value": "Herald of the Storm"
  },
  {
    "key": "herald-of-war",
    "value": "Herald of War"
  },
  {
    "key": "heralds-of-the-destroyer",
    "value": "Heralds of the Destroyer"
  },
  {
    "key": "hesitation-bane-of-deeds",
    "value": "Hesitation, Bane of Deeds"
  },
  {
    "key": "hetairos",
    "value": "Hetairos"
  },
  {
    "key": "hide-of-the-silent-hunter",
    "value": "Hide of the Silent Hunter"
  },
  {
    "key": "history",
    "value": "History"
  },
  {
    "key": "hoarfrost",
    "value": "Hoarfrost"
  },
  {
    "key": "hold",
    "value": "Hold!"
  },
  {
    "key": "holy-fire",
    "value": "Holy Fire"
  },
  {
    "key": "homing-winds",
    "value": "Homing Winds"
  },
  {
    "key": "hone-blades",
    "value": "Hone Blades"
  },
  {
    "key": "honor-a-void-of-self",
    "value": "Honor, a Void of Self"
  },
  {
    "key": "horagai-master",
    "value": "Horagai Master"
  },
  {
    "key": "hubris",
    "value": "Hubris"
  },
  {
    "key": "hurl",
    "value": "Hurl"
  },
  {
    "key": "hurl-it",
    "value": "Hurl It!"
  },
  {
    "key": "hymn-of-the-victor",
    "value": "Hymn of the Victor"
  },
  {
    "key": "hymns-of-war",
    "value": "Hymns of War"
  },
  {
    "key": "hyperadrenal-stimulation",
    "value": "Hyperadrenal Stimulation"
  },
  {
    "key": "hypercatalytic-discharge",
    "value": "Hypercatalytic Discharge"
  },
  {
    "key": "hypercortical-stimulation",
    "value": "Hypercortical Stimulation"
  },
  {
    "key": "hyperkeratinism",
    "value": "Hyperkeratinism"
  },
  {
    "key": "hypersynaptic-bonding",
    "value": "Hypersynaptic Bonding"
  },
  {
    "key": "hypothalamic-suppression",
    "value": "Hypothalamic Suppression"
  },
  {
    "key": "ice-armor",
    "value": "Ice Armor"
  },
  {
    "key": "ice-flesh-and-blood",
    "value": "Ice, Flesh and Blood"
  },
  {
    "key": "igneolithic-mastery",
    "value": "Igneolithic Mastery"
  },
  {
    "key": "ignite",
    "value": "Ignite"
  },
  {
    "key": "immolation",
    "value": "Immolation"
  },
  {
    "key": "impact",
    "value": "Impact X"
  },
  {
    "key": "imperial-oplon",
    "value": "Imperial Oplon"
  },
  {
    "key": "implacable",
    "value": "Implacable"
  },
  {
    "key": "imposing-excellence",
    "value": "Imposing Excellence"
  },
  {
    "key": "in-the-fold",
    "value": "In the Fold"
  },
  {
    "key": "indiscriminate-omnivore",
    "value": "Indiscriminate Omnivore"
  },
  {
    "key": "indomitable",
    "value": "Indomitable X"
  },
  {
    "key": "induce-lethargy",
    "value": "Induce Lethargy"
  },
  {
    "key": "induce-vigor",
    "value": "Induce Vigor"
  },
  {
    "key": "induced-aggression",
    "value": "Induced Aggression"
  },
  {
    "key": "induced-fawn-response",
    "value": "Induced Fawn Response"
  },
  {
    "key": "induced-hyperkinesis",
    "value": "Induced Hyperkinesis"
  },
  {
    "key": "induced-hypoxia",
    "value": "Induced Hypoxia"
  },
  {
    "key": "inevitable-end",
    "value": "Inevitable End"
  },
  {
    "key": "infantry-tactics",
    "value": "Infantry Tactics"
  },
  {
    "key": "infernal-branding",
    "value": "Infernal Branding"
  },
  {
    "key": "infiltration-optimization-strain",
    "value": "Infiltration Optimization Strain"
  },
  {
    "key": "inherited-excellence",
    "value": "Inherited Excellence"
  },
  {
    "key": "initiative",
    "value": "Initiative"
  },
  {
    "key": "insanity",
    "value": "Insanity"
  },
  {
    "key": "inscription-of-balance",
    "value": "Inscription of Balance"
  },
  {
    "key": "inscription-of-impact-resistance",
    "value": "Inscription of Impact Resistance"
  },
  {
    "key": "inscription-of-lighter-alloys",
    "value": "Inscription of Lighter Alloys"
  },
  {
    "key": "inspired",
    "value": "Inspired"
  },
  {
    "key": "inspiring-presence",
    "value": "Inspiring Presence"
  },
  {
    "key": "intrusive-thoughts",
    "value": "Intrusive Thoughts"
  },
  {
    "key": "invocation-of-the-shattering",
    "value": "Invocation of the Shattering"
  },
  {
    "key": "iron-discipline",
    "value": "Iron Discipline"
  },
  {
    "key": "iron-soul-of-discipline",
    "value": "Iron Soul of Discipline"
  },
  {
    "key": "iron-stride",
    "value": "Iron Stride"
  },
  {
    "key": "irregular",
    "value": "Irregular"
  },
  {
    "key": "jadoo-kavach",
    "value": "Jadoo Kavach"
  },
  {
    "key": "jotun-shepard",
    "value": "Jotun Shepard"
  },
  {
    "key": "juggernaut",
    "value": "Juggernaut"
  },
  {
    "key": "just-desserts",
    "value": "Just Desserts"
  },
  {
    "key": "kabuki",
    "value": "Kabuki"
  },
  {
    "key": "kenshibu-dancer",
    "value": "Kenshibu Dancer"
  },
  {
    "key": "kentarch",
    "value": "Kentarch"
  },
  {
    "key": "kiannun-stalker",
    "value": "Kiannun Stalker"
  },
  {
    "key": "kindle-courage",
    "value": "Kindle Courage"
  },
  {
    "key": "kiss-of-the-dilosaur",
    "value": "Kiss of the Dilosaur"
  },
  {
    "key": "kiss-of-the-earth",
    "value": "Kiss of the Earth"
  },
  {
    "key": "lambs-to-the-slaughter",
    "value": "Lambs to the Slaughter"
  },
  {
    "key": "lammelar-flow",
    "value": "Lammelar Flow"
  },
  {
    "key": "laser-shark",
    "value": "Testing the Waters"
  },
  {
    "key": "last-word",
    "value": "Last Word"
  },
  {
    "key": "laurean-lance",
    "value": "Laurean Lance"
  },
  {
    "key": "leader",
    "value": "Leader"
  },
  {
    "key": "legio-i-primigenia",
    "value": "Legio I 'Primigenia'"
  },
  {
    "key": "lessons-of-the-jotun-war",
    "value": "Lessons of the Jotun War"
  },
  {
    "key": "lethal-demise",
    "value": "Lethal Demise"
  },
  {
    "key": "life-anew",
    "value": "Life Anew"
  },
  {
    "key": "life-for-glory",
    "value": "Life for Glory"
  },
  {
    "key": "lifting-winds",
    "value": "Lifting Winds"
  },
  {
    "key": "lightning-bolt",
    "value": "Lightning Bolt"
  },
  {
    "key": "like-gods-among-men",
    "value": "Like Gods Among Men"
  },
  {
    "key": "lineage-commander",
    "value": "Lineage Commander"
  },
  {
    "key": "lineage-guard",
    "value": "Lineage Guard"
  },
  {
    "key": "linebreaker",
    "value": "Linebreaker"
  },
  {
    "key": "linked-neuroreceptors",
    "value": "Linked Neuroreceptors"
  },
  {
    "key": "litanies-of-battle",
    "value": "Litanies of Battle"
  },
  {
    "key": "litanies-of-victory",
    "value": "Litanies of Victory"
  },
  {
    "key": "living-breastplate",
    "value": "Living Breastplate"
  },
  {
    "key": "living-legend",
    "value": "Living Legend"
  },
  {
    "key": "load-the-next-one",
    "value": "Load the Next One!"
  },
  {
    "key": "lobotomytic-override",
    "value": "Lobotomytic Override"
  },
  {
    "key": "lochagos",
    "value": "Lochagos"
  },
  {
    "key": "long-lineage",
    "value": "Long Lineage"
  },
  {
    "key": "longshot",
    "value": "Longshot"
  },
  {
    "key": "loose-formation",
    "value": "Loose Formation"
  },
  {
    "key": "lord-of-roaring-flames",
    "value": "Lord of Roaring Flames"
  },
  {
    "key": "lord-of-the-eternal-mountain",
    "value": "Lord of the Eternal Mountain"
  },
  {
    "key": "lord-of-titans-jotnar",
    "value": "Lord of Titans"
  },
  {
    "key": "lord-of-titans-promethean",
    "value": "Lord of Titans"
  },
  {
    "key": "magma-school",
    "value": "Magma School"
  },
  {
    "key": "magmatic-seep",
    "value": "Magmatic Seep"
  },
  {
    "key": "magnanimity",
    "value": "Magnanimity"
  },
  {
    "key": "magnetic-conduit",
    "value": "Magnetic Conduit"
  },
  {
    "key": "mantle-of-saint-nicholas",
    "value": "Mantle of Saint Nicholas"
  },
  {
    "key": "march-of-giants",
    "value": "March of Giants"
  },

  {
    "key": "mark-of-the-beast",
    "value": "Mark of The Beast"
  },
  {
    "key": "marksman-optimization-strain",
    "value": "Marksman Optimization Strain"
  },
  {
    "key": "martial-prowess",
    "value": "Martial Prowess"
  },
  {
    "key": "mask-of-eaklides",
    "value": "Mask of Eaklides"
  },
  {
    "key": "mask-of-eris",
    "value": "Mask of Eris"
  },
  {
    "key": "massive-frame",
    "value": "Massive Frame"
  },
  {
    "key": "master-manipulator",
    "value": "Master Manipulator"
  },
  {
    "key": "master-of-flesh",
    "value": "Master of Flesh"
  },
  {
    "key": "master-of-the-legions",
    "value": "Master of the Legions"
  },
  {
    "key": "masterwork-weapon",
    "value": "Masterwork Weapon"
  },
  {
    "key": "memory-of-breath",
    "value": "Memory of Breath"
  },
  {
    "key": "memory-of-stone",
    "value": "Memory of Stone"
  },
  {
    "key": "mend-flesh",
    "value": "Mend Flesh"
  },
  {
    "key": "mercy-of-the-reaper",
    "value": "Mercy of the Reaper"
  },
  {
    "key": "microbial-shroud",
    "value": "Microbial Shroud"
  },
  {
    "key": "might-of-everrusk",
    "value": "Might of Everrusk"
  },

  {
    "key": "misery-of-failure-envisioned",
    "value": "Misery of Failure Envisioned"
  },
  {
    "key": "mist-weave",
    "value": "Mist Weave"
  },
  {
    "key": "mistress-of-azure-gales",
    "value": "Mistress of Azure Gales"
  },
  {
    "key": "mistress-of-the-ghostly-reikai",
    "value": "Mistress of the Ghostly Reikai"
  },
  {
    "key": "mistress-of-winsome-mists",
    "value": "Mistress of Winsome Mists"
  },
  {
    "key": "mnemancer-s-apprentice",
    "value": "Mnemancer's Apprentice"
  },
  {
    "key": "mnemancer-s-eye",
    "value": "Mnemancer's Eye"
  },
  {
    "key": "mobility",
    "value": "Mobility"
  },
  {
    "key": "modular-regiments",
    "value": "Modular Regiments"
  },
  {
    "key": "molon-labe",
    "value": "Molon Labe"
  },
  {
    "key": "molten-blades",
    "value": "Molten Blades"
  },
  {
    "key": "momentum",
    "value": "Momentum"
  },
  {
    "key": "monster-inspiration",
    "value": "Monster Inspiration"
  },
  {
    "key": "mouldering-bloom",
    "value": "Mouldering Bloom"
  },
  {
    "key": "bloom",
    "value": "Bloom"
  },
  {
    "key": "culling",
    "value": "Culling"
  },
  {
    "key": "mounted-hunters",
    "value": "Mounted Hunters"
  },
  {
    "key": "mounted-riders",
    "value": "Mounted Riders"
  },
  {
    "key": "murderous-volley",
    "value": "Murderous Volley"
  },
  {
    "key": "muscular-teratosis",
    "value": "Muscular Teratosis"
  },
  {
    "key": "mwater2",
    "value": "MWATER2"
  },
  {
    "key": "neophyte",
    "value": "Neophyte"
  },
  {
    "key": "neuromuscular-overstimulation",
    "value": "Neuromuscular Overstimulation"
  },
  {
    "key": "ninuah-s-tears",
    "value": "Ninuah's Tears"
  },
  {
    "key": "niyantran",
    "value": "Niyantran"
  },
  {
    "key": "no-matter-the-price",
    "value": "No Matter the Price"
  },
  {
    "key": "not-all-who-wander-are-lost",
    "value": "Not All who Wander are Lost"
  },
  {
    "key": "null-mage",
    "value": "Null Mage"
  },
  {
    "key": "obdurate-bone-and-stone",
    "value": "Obdurate Bone and Stone"
  },
  {
    "key": "oblivious",
    "value": "Oblivious"
  },
  {
    "key": "heat-haze",
    "value": "Heat Haze"
  },
  {
    "key": "dark-of-winter",
    "value": "Dark of Winter"
  },
  {
    "key": "obsidian-grafts",
    "value": "Obsidian Grafts"
  },
  {
    "key": "occultists-charm",
    "value": "Occultists Charm"
  },
  {
    "key": "ocular-nerve-hyperstimulation",
    "value": "Ocular Nerve Hyperstimulation"
  },
  {
    "key": "ofuda",
    "value": "Ofuda"
  },
  {
    "key": "olefant-s-roar",
    "value": "Olefant's Roar"
  },
  {
    "key": "omnipotence",
    "value": "Omnipotence"
  },
  {
    "key": "on-soaring-winds",
    "value": "On Soaring Winds"
  },
  {
    "key": "on-your-feet",
    "value": "On Your Feet"
  },
  {
    "key": "opportunists",
    "value": "Opportunists"
  },
  {
    "key": "optimized-fodder",
    "value": "Optimized Fodder"
  },
  {
    "key": "optio",
    "value": "Optio"
  },
  {
    "key": "othismos",
    "value": "Othismos"
  },
  {
    "key": "overcharge",
    "value": "Overcharge"
  },
  {
    "key": "overkill-states",
    "value": "Overkill"
  },
  {
    "key": "overrun",
    "value": "Overrun"
  },
  {
    "key": "overtax-nervous-system",
    "value": "Overtax Nervous System"
  },
  {
    "key": "overwhelm",
    "value": "Overwhelm"
  },
  {
    "key": "pack-tactics",
    "value": "Pack Tactics"
  },
  {
    "key": "paragon-of-war",
    "value": "Paragon of War"
  },
  {
    "key": "parasitic-hyperstimulation",
    "value": "Parasitic Hyperstimulation"
  },
  {
    "key": "parry",
    "value": "Parry"
  },
  {
    "key": "path-of-righteousness",
    "value": "Path of Righteousness"
  },
  {
    "key": "pathfinders",
    "value": "Pathfinders"
  },
  {
    "key": "penance",
    "value": "Penance"
  },
  {
    "key": "perfectly-balanced",
    "value": "Perfectly Balanced"
  },
  {
    "key": "personal-bodyguard",
    "value": "Personal Bodyguard"
  },
  {
    "key": "personal-entourage",
    "value": "Personal Entourage"
  },
  {
    "key": "personal-guard",
    "value": "Personal Guard"
  },
  {
    "key": "phalanx",
    "value": "Phalanx"
  },
  {
    "key": "pheromantic-compulsion",
    "value": "Pheromantic Compulsion"
  },
  {
    "key": "pheromantic-drive",
    "value": "Pheromantic Drive"
  },
  {
    "key": "pick-the-quarry",
    "value": "Pick the Quarry"
  },
  {
    "key": "pike-formation",
    "value": "Pike Formation"
  },
  {
    "key": "planting-an-ambush",
    "value": "Planting an Ambush"
  },
  {
    "key": "point-secure",
    "value": "Point Secure"
  },
  {
    "key": "pounce",
    "value": "Pounce"
  },
  {
    "key": "power-of-the-voice",
    "value": "Power of the Voice"
  },
  {
    "key": "powerful-presence",
    "value": "Powerful Presence"
  },
  {
    "key": "practitioner-biomancy",
    "value": "Practitioner (Biomancy)"
  },
  {
    "key": "practitioner-pheromancy",
    "value": "Practitioner (Pheromancy)"
  },
  {
    "key": "precise-shot",
    "value": "Precise Shot"
  },
  {
    "key": "predatory-shriek",
    "value": "Predatory Shriek"
  },
  {
    "key": "preservation-protocols",
    "value": "Preservation Protocols"
  },
  {
    "key": "preservation-protocols-action",
    "value": "Preservation Protocols"
  },
  {
    "key": "preternatural-focus",
    "value": "Preternatural Focus"
  },
  {
    "key": "priest",
    "value": "Priest X"
  },
  {
    "key": "prijm-khanjar",
    "value": "Prijm Khanjar"
  },
  {
    "key": "primal-cacophony",
    "value": "Primal Cacophony"
  },
  {
    "key": "primodynamic-globe",
    "value": "Primodynamic Globe"
  },
  {
    "key": "prince-of-autumn",
    "value": "Prince of Autumn"
  },
  {
    "key": "prince-of-spring",
    "value": "Prince of Spring"
  },
  {
    "key": "prince-of-summer",
    "value": "Prince of Summer"
  },
  {
    "key": "prince-of-the-setting-moon",
    "value": "Prince of the Setting Moon"
  },
  {
    "key": "prince-of-winter",
    "value": "Prince of Winter"
  },
  {
    "key": "privileged-observer",
    "value": "Privileged Observer"
  },
  {
    "key": "profane-reliquary",
    "value": "Profane Reliquary"
  },
  {
    "key": "professional-troops",
    "value": "Professional Troops"
  },
  {
    "key": "promise-of-flesh",
    "value": "Promise of Flesh"
  },
  {
    "key": "pronunciation-weavers",
    "value": "How to Pronounce - Weaver Courts"
  },
  {
    "key": "propagate",
    "value": "Propagate"
  },
  {
    "key": "prophecy-unfulfilled",
    "value": "Prophecy Unfulfilled"
  },
  {
    "key": "protective-glyphs",
    "value": "Protective Glyphs"
  },
  {
    "key": "proven-warriors",
    "value": "Proven Warriors"
  },
  {
    "key": "prowl",
    "value": "Prowl"
  },
  {
    "key": "proximity-sensors",
    "value": "Proximity Sensors"
  },
  {
    "key": "purification-rites",
    "value": "Purification Rites"
  },
  {
    "key": "pyroclast",
    "value": "Pyroclast"
  },
  {
    "key": "quench-blades",
    "value": "Quench Blades"
  },
  {
    "key": "quicksilver-strike",
    "value": "Quicksilver Strike"
  },
  {
    "key": "raid-leader",
    "value": "Raid Leader"
  },
  {
    "key": "raid-tactics",
    "value": "Raid Tactics!"
  },
  {
    "key": "rake-attack",
    "value": "Rake Attack"
  },
  {
    "key": "rampage",
    "value": "Rampage"
  },
  {
    "key": "rancor",
    "value": "Rancor"
  },
  {
    "key": "veil-of-undergrowth",
    "value": "Veil of Undergrowth"
  },
  {
    "key": "forest-s-embrace",
    "value": "Forest's Embrace"
  },
  {
    "key": "rapid-blossoming",
    "value": "Rapid Blossoming"
  },
  {
    "key": "sun-crown",
    "value": "Sun Crown"
  },
  {
    "key": "abundant-harvest",
    "value": "Abundant Harvest"
  },
  {
    "key": "wild-spirit",
    "value": "Wild Spirit"
  },
  {
    "key": "glacial-presence",
    "value": "Glacial Presence"
  },
  {
    "key": "seed-of-spring",
    "value": "Seed of Spring"
  },
  {
    "key": "seed-of-autumn",
    "value": "Seed of Autumn"
  },
  {
    "key": "seed-of-winter",
    "value": "Seed of Winter"
  },
  {
    "key": "seed-of-summer",
    "value": "Seed of Summer"
  },

  {
    "key": "rapid-displacement",
    "value": "Rapid Displacement"
  },
  {
    "key": "rapid-volley",
    "value": "Rapid Volley"
  },
  {
    "key": "raven-messengers",
    "value": "Raven Messengers"
  },
  {
    "key": "reaper-s-bloom",
    "value": "Reaper's Bloom"
  },
  {
    "key": "recorder-of-all-deeds",
    "value": "Recorder of all Deeds"
  },
  {
    "key": "refined-beyond-nature",
    "value": "Refined Beyond Nature"
  },
  {
    "key": "regalia-of-the-empire",
    "value": "Regalia of the Empire"
  },
  {
    "key": "regeneration",
    "value": "Regeneration X"
  },
  {
    "key": "reign-of-terror",
    "value": "Reign of Terror"
  },
  {
    "key": "reigning-season",
    "value": "Reigning Season"
  },
  {
    "key": "reincarnate",
    "value": "Reincarnate"
  },
  {
    "key": "reinforce",
    "value": "Reinforce"
  },
  {
    "key": "rejuvenation",
    "value": "Rejuvenation"
  },
  {
    "key": "relentless",
    "value": "Relentless"
  },
  {
    "key": "relentless-blows",
    "value": "Relentless Blows"
  },
  {
    "key": "relentless-march",
    "value": "Relentless March"
  },
  {
    "key": "relic-bearer",
    "value": "Relic Bearer"
  },
  {
    "key": "remembered",
    "value": "Remembered"
  },
  {
    "key": "remembrance-of-the-core",
    "value": "Remembrance of the Core"
  },
  {
    "key": "remembrance-of-the-core-de",
    "value": "Remembrance of the Core"
  },
  {
    "key": "remorseless-hunter",
    "value": "Remorseless Hunter"
  },
  {
    "key": "repose-in-healing-spring",
    "value": "Repose in Healing Spring"
  },
  {
    "key": "reprocessing-agents",
    "value": "Reprocessing Agents"
  },
  {
    "key": "reshape-destiny",
    "value": "Reshape Destiny"
  },
  {
    "key": "resilience",
    "value": "Resilience"
  },
  {
    "key": "resist",
    "value": "Resist"
  },
  {
    "key": "resolve",
    "value": "Resolve"
  },
  {
    "key": "resonance",
    "value": "Resonance"
  },
  {
    "key": "resonance-receptors",
    "value": "Resonance Receptors"
  },
  {
    "key": "resounding-malevolence",
    "value": "Resounding Malevolence"
  },
  {
    "key": "reyngeir-the-god-spear",
    "value": "Reyngeir, the God Spear"
  },
  {
    "key": "ride-the-lightning",
    "value": "Ride the Lightning"
  },
  {
    "key": "rider",
    "value": "Rider"
  },
  {
    "key": "rime-storm",
    "value": "Rime Storm"
  },
  {
    "key": "rjoda-the-red-bringer",
    "value": "Rjóða, the Red Bringer"
  },
  {
    "key": "roar-of-the-awekhwge",
    "value": "Roar of the Awe'khwge"
  },
  {
    "key": "rock-shaping",
    "value": "Rock Shaping"
  },
  {
    "key": "rooted-might",
    "value": "Rooted Might"
  },
  {
    "key": "roots-of-stone",
    "value": "Roots of Stone"
  },
  {
    "key": "ruler-of-manheim",
    "value": "Ruler of Manheim"
  },
  {
    "key": "runeforged-plate",
    "value": "Runeforged Plate"
  },
  {
    "key": "runeforged-plate-de",
    "value": "Runeforged Plate"
  },
  {
    "key": "ruthless-competence",
    "value": "Ruthless Competence"
  },
  {
    "key": "sacred-warriors",
    "value": "Sacred Warriors"
  },
  {
    "key": "saint-s-favor",
    "value": "Saint's Favor"
  },
  {
    "key": "sanctified-labaron",
    "value": "Sanctified Labaron"
  },
  {
    "key": "savage",
    "value": "Savage"
  },
  {
    "key": "savage-retaliation",
    "value": "Savage Retaliation"
  },
  {
    "key": "sayf",
    "value": "Sayf"
  },
  {
    "key": "scars-of-endekar",
    "value": "Scars of Endekar"
  },
  {
    "key": "schemophore",
    "value": "Schemophore"
  },
  {
    "key": "school-of-air",
    "value": "School of Air"
  },
  {
    "key": "school-of-earth",
    "value": "School of Earth"
  },
  {
    "key": "school-of-fire",
    "value": "School of Fire"
  },
  {
    "key": "school-of-water",
    "value": "School of Water"
  },
  {
    "key": "scorpion",
    "value": "Scorpion"
  },
  {
    "key": "winter-s-bite",
    "value": "Winter's Bite"
  },
  {
    "key": "searing-sandstorm",
    "value": "Searing Sandstorm"
  },
  {
    "key": "seasoned-veteran",
    "value": "Seasoned Veteran"
  },
  {
    "key": "seeking-winds",
    "value": "Seeking Winds"
  },
  {
    "key": "seize-the-advantage",
    "value": "Seize the Advantage"
  },
  {
    "key": "seize-the-day",
    "value": "Seize the Day"
  },
  {
    "key": "seizing-a-new-future",
    "value": "Seizing a New Future"
  },
  {
    "key": "servite",
    "value": "Servite"
  },
  {
    "key": "chitinous-metamorphosis",
    "value": "Chitinous Metamorphosis"
  },
  {
    "key": "the-voice-s-calling",
    "value": "The Voice's Calling"
  },
  {
    "key": "cloud-seeding",
    "value": "Cloud Seeding"
  },
  {
    "key": "shamisen",
    "value": " Shamisen"
  },
  {
    "key": "shield",
    "value": "Shield"
  },
  {
    "key": "shield-biter",
    "value": "Shield Biter"
  },
  {
    "key": "shock",
    "value": "Shock"
  },
  {
    "key": "show-the-path",
    "value": "Show the Path"
  },
  {
    "key": "shulaat",
    "value": "Shu'laat"
  },
  {
    "key": "singing-bullets",
    "value": "Singing Bullets"
  },
  {
    "key": "siphon-strength",
    "value": "Siphon Strength"
  },
  {
    "key": "skald",
    "value": "Skald"
  },
  {
    "key": "skofnung",
    "value": "Skofnung"
  },
  {
    "key": "skorge",
    "value": "Skorge"
  },
  {
    "key": "skyvald",
    "value": "Skývald"
  },
  {
    "key": "slain-bigger",
    "value": "Slain Bigger"
  },
  {
    "key": "slayer-s-brand",
    "value": "Slayer's Brand"
  },
  {
    "key": "smite",
    "value": "Smite"
  },
  {
    "key": "songs-of-the-descent",
    "value": "Songs of the Descent"
  },
  {
    "key": "soothing-tides",
    "value": "Soothing Tides"
  },
  {
    "key": "sorcerous-blessing",
    "value": "Sorcerous Blessing"
  },
  {
    "key": "soul-reaper",
    "value": "Soul Reaper"
  },
  {
    "key": "sowing-shot",
    "value": "Sowing Shot"
  },
  {
    "key": "spined-descent",
    "value": "Spined Descent"
  },
  {
    "key": "spirit-breeze",
    "value": "Spirit Breeze"
  },
  {
    "key": "spiteful-winds",
    "value": "Spiteful Winds"
  },
  {
    "key": "spring-s-vigor",
    "value": "Spring's Vigor"
  },
  {
    "key": "stabilize",
    "value": "Stabilize"
  },
  {
    "key": "standard-bearer",
    "value": "Standard Bearer"
  },
  {
    "key": "standard-of-last-oration",
    "value": "Standard of Last Oration"
  },
  {
    "key": "standard-of-steel",
    "value": "Standard of Steel"
  },
  {
    "key": "steel-enhancements",
    "value": "Steel Enhancements"
  },
  {
    "key": "steel-school",
    "value": "Steel School"
  },
  {
    "key": "stoic",
    "value": "Stoic"
  },
  {
    "key": "stone-spikes",
    "value": "Stone Spikes"
  },
  {
    "key": "strain-expression",
    "value": "Strain Expression"
  },
  {
    "key": "strength-and-honor",
    "value": "Strength and Honor"
  },
  {
    "key": "stride",
    "value": "Stride"
  },
  {
    "key": "sub-faction-rules-100k",
    "value": "Army Rules"
  },
  {
    "key": "subtle-sow",
    "value": "Subtle Sow"
  },
  {
    "key": "sunder",
    "value": "Sunder"
  },
  {
    "key": "superior-creations",
    "value": "Superior Creations"
  },
  {
    "key": "superiority",
    "value": "Superiority"
  },
  {
    "key": "support",
    "value": "Support X"
  },
  {
    "key": "suppress-higher-functions",
    "value": "Suppress Higher Functions"
  },
  {
    "key": "suppress-pain",
    "value": "Suppress Pain"
  },
  {
    "key": "suppress-survival-instinct",
    "value": "Suppress Survival Instinct"
  },
  {
    "key": "sureshot",
    "value": "Sureshot"
  },
    {
    "key": "ensnaring-barrage",
    "value": "Ensnaring Barrage"
  },
  {
    "key": "surrounded-by-fear-and-dead-men",
    "value": "Surrounded by Fear and Dead Men"
  },
  {
    "key": "swarm",
    "value": "Swarm"
  },
  {
    "key": "sweeping-step",
    "value": "Sweeping Step"
  },
  {
    "key": "swift-retreat",
    "value": "Swift Retreat"
  },
  {
    "key": "swirling-embrace",
    "value": "Swirling Embrace"
  },
  {
    "key": "symbiotic-command",
    "value": "Symbiotic Command"
  },
  {
    "key": "tactical-fabricants",
    "value": "Tactical Fabricants"
  },
  {
    "key": "take-cover",
    "value": "Take Cover"
  },
  {
    "key": "take-flight",
    "value": "Take Flight!"
  },
  {
    "key": "take-the-flanks",
    "value": "Take the Flanks!"
  },
  {
    "key": "takigyo-training",
    "value": "Takigyo Training"
  },
  {
    "key": "talented",
    "value": "Talented"
  },
  {
    "key": "telencephalic-lateralization",
    "value": "Telencephalic Lateralization"
  },
  {
    "key": "temper-plate",
    "value": "Temper Plate"
  },
  {
    "key": "temper-resolve",
    "value": "Temper Resolve"
  },
  {
    "key": "tempered-goad",
    "value": "Tempered Goad"
  },
  {
    "key": "tempo",
    "value": "Tempo"
  },
  {
    "key": "tenacious",
    "value": "Tenacious X"
  },
  {
    "key": "terrifying",
    "value": "Terrifying X"
  },
  {
    "key": "testaments-to-honor",
    "value": "Testaments to Honor"
  },
  {
    "key": "thaumaturge",
    "value": "Thaumaturge"
  },
  {
    "key": "the-ardent-creed",
    "value": "The Ardent Creed"
  },
  {
    "key": "the-big-game-hunt",
    "value": "The Big Game Hunt"
  },
  {
    "key": "the-clan-creed",
    "value": "The Clan Creed"
  },
  {
    "key": "the-crown-of-ushkelodh",
    "value": "The Crown of Ushkelodh"
  },
  {
    "key": "the-first-blessing",
    "value": "The First Blessing"
  },
  {
    "key": "the-flame-flickers",
    "value": "The Flame Flickers"
  },
  {
    "key": "the-flesh-cleaver",
    "value": "The Flesh Cleaver"
  },
  {
    "key": "the-four-harbingers",
    "value": "The Four Harbingers"
  },
  {
    "key": "the-horn-of-ronan",
    "value": "The Horn of Ronan"
  },
  {
    "key": "the-matriarch-walks",
    "value": "The Matriarch Walks"
  },
  {
    "key": "the-reaping-crook",
    "value": "The Reaping Crook"
  },
  {
    "key": "the-shattering",
    "value": "The Shattering"
  },
  {
    "key": "the-spirit-glimmers",
    "value": "The Spirit Glimmers"
  },
  {
    "key": "the-spirit-shines",
    "value": "The Spirit Shines"
  },
  {
    "key": "the-tempered-creed",
    "value": "The Tempered Creed"
  },
  {
    "key": "thegn",
    "value": "Thegn"
  },
  {
    "key": "thesis-antithesis-synthesis",
    "value": "Thesis/Antithesis/Synthesis"
  },
  {
    "key": "thundering-charge",
    "value": "Thundering Charge"
  },
  {
    "key": "thunderous-assault",
    "value": "Thunderous Assault"
  },
  {
    "key": "tidal-wave",
    "value": "Tidal Wave"
  },
  {
    "key": "tip-of-the-lance",
    "value": "Tip of the Lance"
  },
  {
    "key": "to-banish-the-darkness",
    "value": " To Banish the Darkness"
  },
  {
    "key": "to-cast-out-the-daemon",
    "value": "To Cast Out the Daemon"
  },
  {
    "key": "to-restore-the-faith",
    "value": "To Restore the Faith"
  },
  {
    "key": "to-the-end",
    "value": "To the End"
  },
  {
    "key": "to-the-last-breath",
    "value": "To the Last Breath"
  },
  {
    "key": "tontorr-rider",
    "value": "Tontorr Rider"
  },
  {
    "key": "torque",
    "value": "Torque"
  },
  {
    "key": "torrential-fire",
    "value": "Torrential Fire"
  },
  {
    "key": "tourney-champion",
    "value": "Tourney Champion"
  },
  {
    "key": "towering-presence",
    "value": "Towering Presence"
  },
  {
    "key": "trample",
    "value": "Trample X"
  },
  {
    "key": "translocation",
    "value": "Translocation"
  },
  {
    "key": "trial-of-hakari-ishi",
    "value": "Trial of hakari-ishi"
  },
  {
    "key": "trial-of-will",
    "value": "Trial of Will"
  },
  {
    "key": "tribal-spear",
    "value": "Tribal Spear"
  },
  {
    "key": "tribe-s-pride",
    "value": "Tribe's Pride"
  },
  {
    "key": "tricks-of-the-trade",
    "value": "Tricks of the Trade"
  },
  {
    "key": "trident-strike",
    "value": "Trident Strike"
  },
  {
    "key": "ty-jokull-the-rimeheart",
    "value": "Ty Jokull, the Rimeheart"
  },
  {
    "key": "unassailable-authority",
    "value": "Unassailable Authority"
  },
  {
    "key": "undying-devotion",
    "value": "Undying Devotion"
  },
  {
    "key": "unhallowed-ground",
    "value": "Unhallowed Ground"
  },
  {
    "key": "unholy-baptism",
    "value": "Unholy Baptism"
  },
  {
    "key": "unholy-mastery",
    "value": "Unholy Mastery"
  },
  {
    "key": "unholy-sacrament",
    "value": "Unholy Sacrament"
  },
  {
    "key": "unholy-sacrament-de",
    "value": "Unholy Sacrament"
  },
  {
    "key": "unmake-armor",
    "value": "Unmake Armor"
  },
  {
    "key": "unstable-alloys",
    "value": "Unstable Alloys"
  },
  {
    "key": "unstable-enhancement",
    "value": "Unstable Enhancement"
  },
  {
    "key": "unstoppable",
    "value": "Unstoppable"
  },
  {
    "key": "until-we-have-to",
    "value": "'Until We Have To'"
  },
  {
    "key": "untouchable",
    "value": "Untouchable"
  },
  {
    "key": "unyielding",
    "value": "Unyielding"
  },
  {
    "key": "unyielding-kata",
    "value": "Unyielding Kata"
  },
  {
    "key": "up-in-arms",
    "value": "Up In Arms!"
  },
  {
    "key": "vanguard",
    "value": "Vanguard X"
  },
  {
    "key": "venerable",
    "value": "Venerable"
  },
  {
    "key": "veteran-sergeants",
    "value": "Veteran Sergeants"
  },
  {
    "key": "vexilla-of-the-lost",
    "value": "Vexilla of the Lost"
  },
  {
    "key": "viaticum",
    "value": "Viaticum"
  },
  {
    "key": "vicious-assault",
    "value": "Vicious Assault"
  },
  {
    "key": "vinda-the-dancer",
    "value": "Vinda, the Dancer"
  },
  {
    "key": "violence-of-action",
    "value": "Violence of Action"
  },
  {
    "key": "violent-delirium",
    "value": "Violent Delirium"
  },
  {
    "key": "violent-geyser",
    "value": "Violent Geyser"
  },
  {
    "key": "visage",
    "value": "Visage"
  },
  {
    "key": "visage-of-death",
    "value": "Visage of Death"
  },
  {
    "key": "visceral-bombardment",
    "value": "Visceral Bombardment"
  },
  {
    "key": "vision",
    "value": "Vision"
  },
  {
    "key": "vision-of-conquest",
    "value": "Vision of Conquest"
  },
  {
    "key": "vision-of-death",
    "value": "Vision of Death"
  },
  {
    "key": "vision-of-war",
    "value": "Vision of War"
  },
  {
    "key": "vizier-of-the-morning-star",
    "value": "Vizier of the Morning Star"
  },
  {
    "key": "voice-of-conquest",
    "value": "Voice of Conquest"
  },
  {
    "key": "wall-of-pikes",
    "value": "Wall of Pikes"
  },
  {
    "key": "war-brethren",
    "value": "War-Brethren"
  },
  {
    "key": "warbringer-s-light",
    "value": "Warbringer's Light"
  },
  {
    "key": "ward-preceptor",
    "value": "Ward Preceptor"
  },
  {
    "key": "water-elemental",
    "value": "Water Elemental"
  },
  {
    "key": "water-to-blood",
    "value": "Water to Blood"
  },
  {
    "key": "way-of-the-kensei",
    "value": "Way of the Kensei"
  },
  {
    "key": "wealth-of-a-hundred-raids",
    "value": "Wealth of a Hundred Raids"
  },
  {
    "key": "weapon-master",
    "value": "Weapon  Master"
  },
  {
    "key": "weapon-platform",
    "value": "Weapon Platform"
  },
  {
    "key": "wedge",
    "value": "Wedge!"
  },
  {
    "key": "what-we-did-in-life-will-echo-in-eternity",
    "value": "What we did in Life will Echo in Eternity"
  },
  {
    "key": "whispered-illusion",
    "value": "Whispered Illusion"
  },
  {
    "key": "wild-beasts",
    "value": "Wild Beasts"
  },
  {
    "key": "wild-youth",
    "value": "Wild Youth"
  },
  {
    "key": "wind-kissed-blades",
    "value": "Wind Kissed Blades"
  },
  {
    "key": "wind-s-children",
    "value": "Wind's Children"
  },
  {
    "key": "wither-away",
    "value": "Wither Away"
  },
  {
    "key": "witness-of-the-void",
    "value": "Witness of the Void"
  },
  {
    "key": "wizard",
    "value": "Wizard X"
  },
  {
    "key": "wolf-aspect",
    "value": "Wolf"
  },
  {
    "key": "word-of-the-voice",
    "value": "Word of the Voice"
  },
  {
    "key": "world-breakers",
    "value": "World Breakers"
  },
  {
    "key": "wreathed-in-fire",
    "value": "Wreathed in Fire"
  },
  {
    "key": "written-in-bones",
    "value": "Written in Bones"
  },
  {
    "key": "snapshot",
    "value": "Snapshot"
  },
  {
    "key": "mighty-swing",
    "value": "Mighty Swing"
  },
  {
    "key": "affliction-absorption",
    "value": "Affliction Absorption"
  },
  {
    "key": "titanic-defiance",
    "value": "Titanic Defiance"
  },
  {
    "key": "honor-beyond-death",
    "value": "Honor Beyond Death"
  },
  {
    "key": "wrathful-momentum",
    "value": "Wrathful Momentum"
  },
  {
    "key": "waveborne-form",
    "value": "Waveborne Form"
  },
  {
    "key": "wavebreaker-form",
    "value": "Wavebreaker Form"
  },
  {
    "key": "arcane-tide-form",
    "value": "Arcane Tide Form"
  },
  {
    "key": "tidecaller",
    "value": "Tidecaller"
  },
  {
    "key": "tidal-summons",
    "value": "Tidal Summons"
  },
  {
    "key": "hierotekton",
    "value": "Hierotekton"
  }
]
